export class LocalStorageService {
  persist = async (key: string, value: string | TObject) => {
    localStorage?.setItem(
      key,
      typeof value === "string" ? value : JSON.stringify(value)
    );
  };
  fetch = async (key: string) => {
    const item = localStorage?.getItem(key);
    return item;
  };
  remove = async (key: string) => {
    localStorage?.removeItem(key);
  };
  clear = () => {
    localStorage?.clear();
  };

  /**
   * Role-based token storage methods
   */

  // Store token for a specific user role
  persistToken = async (
    role: number | string,
    token: string
  ): Promise<void> => {
    const key = `authToken_${role}`;
    localStorage?.setItem(key, token);
  };

  // Fetch token for a specific user role
  fetchToken = async (role: number | string): Promise<string | null> => {
    const key = `authToken_${role}`;
    return localStorage?.getItem(key);
  };

  // Remove token for a specific user role
  removeToken = async (role: number | string): Promise<void> => {
    const key = `authToken_${role}`;
    localStorage?.removeItem(key);
  };

  // Get all stored role tokens (for debugging/admin purposes)
  getAllTokens = (): Record<string, string> => {
    const tokens: Record<string, string> = {};
    for (let i = 0; i < localStorage?.length; i++) {
      const key = localStorage?.key(i);
      if (key && key.startsWith("authToken_")) {
        const value = localStorage?.getItem(key);
        if (value) tokens[key] = value;
      }
    }
    return tokens;
  };

  // Clear all role-based tokens
  clearAllTokens = (): void => {
    const keys: string[] = [];
    for (let i = 0; i < localStorage?.length; i++) {
      const key = localStorage?.key(i);
      if (key && key.startsWith("authToken_")) {
        keys.push(key);
      }
    }
    keys.forEach((key) => localStorage?.removeItem(key));
  };
}
